import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export default function getFormattedDateWithTime(
  date: string | number,
  format = 'DD.MM.YYYY HH:mm',
  keepLocalTime: boolean | undefined = undefined,
) {
  return dayjs.utc(date).utc(keepLocalTime).format(format);
}
